import React from "react";
import ModalPopup from "../../Common/Modal/Modal";
import { IoClose } from "react-icons/io5";
import { Tooltip } from "antd";

const ContactViewModal = ({ open, onClose, contact }) => {
  const displayValue = (value) => value || "-";

  const Row = ({ label, value }) => (
    <div className="grid grid-cols-2 gap-[1vw]">
      <p className="text-[1vw] font-bold text-[#1F487C]">{label}</p>

      {String(value || "").length > 25 ? (
        <Tooltip
          placement="top"
          title={value}
          color="white"
          overlayInnerStyle={{
            color: "#1F487C",
          }}
        >
          <p className="text-[1vw] text-[#1F487C] cursor-pointer">
            {`${String(value).slice(0, 25)}...`}
          </p>
        </Tooltip>
      ) : (
        <p className="text-[1vw] text-[#1F487C]">{displayValue(value)}</p>
      )}
    </div>
  );

  return (
    <ModalPopup
      show={open}
      onClose={onClose}
      // height="30vw"
      width="40vw"
      closeicon={false}
    >
      <div className="flex flex-col h-full">
        <div className="flex justify-between items-center">
          <h1 className="text-[#1F487C] text-[1.5vw] font-bold">
            CONTACT DETAILS
          </h1>

          <IoClose
            className="cursor-pointer text-gray-600 w-[1.5vw] h-[1.5vw]"
            onClick={onClose}
          />
        </div>

        <div className="border-[#1F487C] border-l-[0.1vw] border-t-[0.1vw] border-r-[0.25vw] border-b-[0.25vw] rounded-[0.5vw] mt-[1vw] p-[1vw] flex flex-col gap-[0.8vw] bg-white">
          <Row label="Name" value={contact?.contact_name} />
          <Row label="Designation" value={contact?.designation} />
          <Row label="Organisation" value={contact?.organisation} />
          <Row label="Category" value={contact?.category} />
          <Row label="Priority" value={contact?.priority} />
          <Row label="Email" value={contact?.email} />
          <Row label="Phone" value={contact?.phone} />
          <Row label="Notes" value={contact?.notes} />
        </div>
      </div>
    </ModalPopup>
  );
};

export default ContactViewModal;